<template>
  <v-toolbar flat color="#f6f7f2">
    <!-- <v-toolbar-title>您的商户ID是：8899</v-toolbar-title> -->
    <v-toolbar-title>
      {{ $t("toolbar.nickname", { name: userInfo.name || "" }) }}
    </v-toolbar-title>
    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn flat @click="$router.push({ name: 'userinfo' })">
        {{ $t("toolbar.info") }}
      </v-btn>
      <v-btn flat @click="$router.push({ name: 'order-list' })">
        {{ $t("toolbar.history") }}
      </v-btn>
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <v-badge overlap color="#f0432c">
      <template v-slot:badge>
        <span>{{ shoppingCart.total }}</span>
      </template>

      <v-btn
        color="#7fba00"
        fab
        big
        @click="$router.push({ name: 'shopping-cart' })"
      >
        <v-icon color="#fff">shopping_cart</v-icon>
      </v-btn>
    </v-badge>
  </v-toolbar>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState(["userInfo", "shoppingCart"])
  },
  mounted() {
    this.loadShoppingCart();
  },
  methods: {
    ...mapActions(["loadShoppingCart"])
  }
};
</script>

<style scoped lang="sass" src="./toolbar.sass"></style>
